import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import CloseIcon from '@material-ui/icons/Close'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import Slide from '@material-ui/core/Slide'
import Dialog from '@material-ui/core/Dialog'
import AddIcon from '@material-ui/icons/Add'
import Fab from '@material-ui/core/Fab'
import CircularProgress from '@material-ui/core/CircularProgress'

import { DEFAULT_LOCATION } from '../../config'
import { styles, Wrapper, Centered } from './styles'
import LocationMap from '../../components/LocationMap'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export const PickLocation = ({ heroConfig, setLocation }) => {
  const [dialogMapOpen, setDialogMapOpen] = useState(false)
  const [newLocation, setNewLocation] = useState({ lat: 0, lng: 0 })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (navigator && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(pos => {
        const coords = pos.coords
        const location = {
          lat: coords.latitude,
          lng: coords.longitude
        }

        setNewLocation(location)
        setLoading(false)
      })
    } else {
      setNewLocation(DEFAULT_LOCATION)
      setLoading(false)
    }
  }, [])

  const handleAddLocation = () => {
    setLocation({
      ...newLocation,
      radius: heroConfig.radius
    })

    setDialogMapOpen(false)
  }

  return (
    <React.Fragment>
      <Wrapper>
        <Fab
          color="primary"
          aria-label="Add"
          onClick={() => setDialogMapOpen(true)}
        >
          <AddIcon color="inherit" />
        </Fab>
      </Wrapper>
      <Dialog fullScreen open={dialogMapOpen} TransitionComponent={Transition}>
        <AppBar position="sticky">
          <Toolbar style={styles.toolbar}>
            <IconButton
              id="btnClose"
              color="inherit"
              aria-label="Menu"
              style={styles.menuButton}
              onClick={() => setDialogMapOpen(false)}
            >
              <CloseIcon />
            </IconButton>
            <Typography
              id="titlePage"
              variant="h6"
              color="inherit"
              style={styles.grow}
            >
              Pick your location
            </Typography>

            <Button
              id="btnLocationAdd"
              color="inherit"
              aria-label="Add"
              style={styles.userButton}
              onClick={() => handleAddLocation()}
            >
              <Typography color="inherit">ADD</Typography>
            </Button>
          </Toolbar>
        </AppBar>
        {!loading ? (
          <LocationMap
            location={{
              lat: newLocation.lat,
              lng: newLocation.lng,
              radius: heroConfig.radius
            }}
            setLocation={setNewLocation}
          />
        ) : (
          <Centered>
            <CircularProgress />
          </Centered>
        )}
      </Dialog>
    </React.Fragment>
  )
}

PickLocation.propTypes = {
  heroConfig: PropTypes.object.isRequired,
  setLocation: PropTypes.func.isRequired
}

export default PickLocation



// WEBPACK FOOTER //
// ./src/components/PickLocation/index.js